import { useCallback } from 'react';
import { useHttpClient } from '../../client/HttpClientContext';
import { useAsyncFunction } from '../../utils/hooks/useAsyncFunction';
import { taxCategoriesCache } from '../../cache';
export const useTaxCategories = () => {
  const httpClient = useHttpClient();
  const getTaxCategories = useCallback(() => {
    return taxCategoriesCache.get('TaxCategoriesCache', httpClient);
  }, [httpClient]);
  return useAsyncFunction(getTaxCategories);
};